// import thunk from 'redux-thunk';

export const asyncFunctionMiddleware =
  (middlewareFuncs) => (storeAPI) => (next) => (action) => {
    // If the "action" is actually a function instead...

    if (typeof action === 'function') {
      // then call the function and pass `dispatch` and `getState` as arguments
      return action(storeAPI.dispatch, storeAPI.getState, middlewareFuncs);
    }

    // Otherwise, it's a normal action - send it onwards
    return next(action);
  };
